import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import FormatIznosa from '../../FormatIznosa';

const styles = {
    kolicinaIcijena: {
        fontFamily: 'monospace'
    }
};

export default class FixedKlijentovPredmetBodyCells extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Table.Cell>
                    {this.props.item.kategorija
                        ? this.props.item.kategorija.ime + (this.props.item.potkategorija ? ' / ' + this.props.item.potkategorija.ime : '')
                        : '-'}
                </Table.Cell>
                <Table.Cell textAlign="right" collapsing style={styles.kolicinaIcijena}>
                    {this.props.item.kolicina}
                </Table.Cell>
                <Table.Cell textAlign="right" collapsing style={styles.kolicinaIcijena}>
                    <FormatIznosa value={this.props.item.vrijednost} suffix={null} />
                </Table.Cell>
                <Table.Cell textAlign="right" collapsing style={styles.kolicinaIcijena}>
                    <FormatIznosa value={this.props.item.kolicina * this.props.item.vrijednost} />
                </Table.Cell>
            </React.Fragment>
        );
    }
}

FixedKlijentovPredmetBodyCells.propTypes = {
    item: PropTypes.object.isRequired
};
